<template>
  <div class="navbg">
    <div class="flexbox nav">
      <div class="allclass" @mouseenter="lmenuShow" @mouseleave="lmenuHide">
        <div class="top">
          <!-- <i class="el-icon-menu"></i> -->
          <img
            src="../../assets/img/icon/menu.svg"
            style="width: 12px; height: 12px"
          />

          全部商品分类
        </div>
        <div
          class="flexbox content"
          v-if="leftmenu || indexleftmenu"
          @mouseleave="rmenuHide"
        >
          <div class="leftmenu">
            <div
              class="flexbox lmcell"
              v-for="(item, index) in menuList"
              :key="item.TGC_ID"
              @mouseenter="rmenuShow(index)"
            >
              <div class="item">
                <img :src="item.TGC_URL" />{{ item.TGC_NAME }}
              </div>
              <div class="jiantou">></div>
            </div>
          </div>
          <div class="rightmenu" v-show="rightmenu">
            <div
              class="flexbox item"
              v-for="item in menuListCh"
              :key="item.TGC_ID"
            >
              <div class="itemh redw">{{ item.TGC_NAME }}</div>
              <div class="flexbox itembox">
                <router-link
                  :to="{
                    name: 'GoodsList',
                    query: {
                      field: it.FIELD,
                      type: 'querymenu',
                      keywords: it.TGC_ID,
                    },
                  }"
                  v-for="it in item.THREECLASS"
                  :key="it.TGC_ID"
                  @click.native="refreshpage"
                  >{{ it.TGC_NAME }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flexbox navbox">
        <div class="navcell">
          <router-link :to="{ name: 'QuickOrder' }" active-class="active"
            >快速下单</router-link
          >
        </div>
        <div class="navcell">
          <router-link :to="{ name: 'Projectorder' }" active-class="active"
            >项目订单</router-link
          >
        </div>
        <div class="navcell" v-if="boot">
          <router-link :to="{ name: 'Yidiorder' }" active-class="active"
            >异地仓订单</router-link
          >
        </div>
        <!-- 
                <div class="navcell">
                    <router-link :to="{name: 'QuickOrder'}">样品申请</router-link>
                </div>
                <div class="navcell">
                    <router-link :to="{name: 'QuickOrder'}">退货申请</router-link>
                </div>
                <div class="navcell">
                    <router-link :to="{name: 'QuickOrder'}">异地仓库订单</router-link>
                </div>
                <div class="navcell">
                    <router-link :to="{name: 'QuickOrder'}">促销订单</router-link>
                </div>
                <div class="navcell">
                    <router-link :to="{name: 'QuickOrder'}">一站式订单</router-link>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance, onBeforeMount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getUrlRelativePath } from "@/util/util.js";
import config from "@/api/config.js";

export default {
  name: "NavHead",
  props: {
    leftmenu: {
      type: Boolean,
    },
    indexleftmenu: {
      type: Boolean,
    },
  },
  setup(props, context) {
    let boot = ref(false);
    //获取项目名称列表
    let getProjectName = () => {
      let data = {
        postType: "getStockByUser",
      };
      proxy.$axios
        .postNoLoadingReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
          boot.value = res.boot;
        });
    };
    let { proxy } = getCurrentInstance();
    let router = useRouter();
    // 获取分类导航数据
    let menuList = ref([]);
    let menuListCh = ref([]);
    let getMenu = () => {
      let url = "/meide/REST/ajaxMdIndex";
      let data = {
        postType: "queryclass",
      };
      proxy.$axios
        .postReq(url, data)
        .then((res) => {
          if (res.success == "true") {
            res.items.ONECLASS.map((item) => {
              item.TGC_URL = config.icoBaseUrl + item.TGC_URL;
            });
            menuList.value = res.items.ONECLASS;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 分类导航的展示隐藏
    let leftmenu = props.leftmenu || ref(false);
    let indexleftmenu = props.indexleftmenu || ref(false);
    let rightmenu = ref(false);
    let lmenuShow = () => {
      leftmenu.value = true;
    };
    let lmenuHide = () => {
      leftmenu.value = false;
    };
    let rmenuShow = (idx) => {
      rightmenu.value = true;
      menuListCh.value = menuList.value[idx].TWOCLASS;
    };
    let rmenuHide = () => {
      rightmenu.value = false;
    };
    // 当前页跳转
    let currenturl = ref("");
    let refreshpage = () => {
      if (currenturl.value == "goodslist") {
        setTimeout(() => {
          router.go(0);
        }, 500);
      }
    };
    onBeforeMount(() => {
      let arrurl = getUrlRelativePath().split("/");
      currenturl.value = arrurl[arrurl.length - 1];
      getMenu();
      getProjectName();
    });
    return {
      leftmenu,
      rightmenu,
      indexleftmenu,
      lmenuShow,
      lmenuHide,
      rmenuShow,
      rmenuHide,
      menuList,
      menuListCh,
      getMenu,
      currenturl,
      refreshpage,
      boot,
    };
  },
};
</script>

<style scoped lang="scss">
.navbg {
  width: 100%;
  box-shadow: 0 5px 6px 0px #e8e8e8;
}
.nav {
  width: 1200px;
  margin: auto;
  .allclass {
    position: relative;
    .top {
      width: 230px;
      height: 40px;
      color: #fff;
      background: #f42434;
      border-radius: 10px 10px 0 0;
      text-align: center;
      line-height: 40px;
      padding-top: 5px;
      i {
        color: #fff;
        margin-right: 5px;
        font-size: 16px;
      }
    }
    .content {
      position: absolute;
      align-items: flex-start;
      z-index: 99;
      max-height: 360px;
      left: 0;
      top: 39px;
      .leftmenu {
        padding: 7px 0;
        background: rgba(0, 0, 0, 0.7);
        width: 230px;
        height: 360px;
        .lmcell {
          padding: 10.5px 15px 10.5px 30px;
          color: #fff;
          justify-content: space-between;
          cursor: default;
          .item {
            display: flex;
            align-items: center;
            font-size: 15px;
            img {
              margin-right: 30px;
              width: 22px;
              height: 22px;
            }
          }
          .jiantou {
            color: #ccc;
            font-weight: bolder;
          }
        }
        .lmcell:hover {
          background: rgb(0, 144, 111);
        }
      }
      .rightmenu {
        width: 970px;
        background: rgb(248, 248, 248);
        height: 360px;
        padding-top: 10px;
        overflow: auto;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        &::-webkit-scrollbar {
          width: 0 !important;
        }
        .item {
          border-bottom: 1px solid #ccc;
          padding: 0 15px;
          .itemh {
            font-size: 12px;
            width: 12%;
          }
          .itembox {
            flex-wrap: wrap;
            width: 88%;
            min-height: 40px;
            a {
              font-size: 12px;
              color: #999;
              padding: 0 15px;
              border-left: 1px solid #ccc;
              margin: 8px 0;
              &:hover {
                color: rgb(244, 36, 52);
              }
            }
          }
        }
      }
    }
  }
  .navbox {
    margin-left: 20px;
    .navcell {
      margin: 0 20px;
      cursor: pointer;
      a {
        display: block;
        font-size: 16px;
        color: #000;
        width: 100%;
        padding: 8px 10px;
      }
    }
    .navcell:hover {
      color: #f42434;
    }
    .navcell.active {
      color: #f42434;
    }
  }
}
.active {
  color: red !important;
}
</style>